module.exports = __webpack_public_path__ + "static/media/apple-icon.2f7ac0f3.svg";